var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 42,
    viewBox: "0 0 35 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1596 29.5351C25.8935 32.8397 17.6961 41.1337 17.6961 41.1337C17.6961 41.1337 9.29768 32.6362 6.23269 29.5351C-0.0983959 23.1294 -0.0983959 12.7437 6.23269 6.33798C12.5638 -0.0677369 22.8285 -0.0677369 29.1596 6.33798C35.4907 12.7437 35.4907 23.1294 29.1596 29.5351Z",
    fill: "#09556F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1 16.5337C23.1 19.516 20.6806 21.9337 17.6961 21.9337C14.7116 21.9337 12.2922 19.516 12.2922 16.5337C12.2922 13.5514 14.7116 11.1337 17.6961 11.1337C20.6806 11.1337 23.1 13.5514 23.1 16.5337Z",
    fill: "#09556F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1596 29.5351C25.8935 32.8397 17.6961 41.1337 17.6961 41.1337C17.6961 41.1337 9.29768 32.6362 6.23269 29.5351C-0.0983959 23.1294 -0.0983959 12.7437 6.23269 6.33798C12.5638 -0.0677369 22.8285 -0.0677369 29.1596 6.33798C35.4907 12.7437 35.4907 23.1294 29.1596 29.5351Z",
    stroke: "#09556F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1 16.5337C23.1 19.516 20.6806 21.9337 17.6961 21.9337C14.7116 21.9337 12.2922 19.516 12.2922 16.5337C12.2922 13.5514 14.7116 11.1337 17.6961 11.1337C20.6806 11.1337 23.1 13.5514 23.1 16.5337Z",
    stroke: "#09556F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/MapIcon.e9701eee66d76467c5a1b1427a993b0c.svg";
export { ForwardRef as ReactComponent };